const signUpDefaultMessage =
  "Error occurred while completing sign up. Please contact support if the issue persists.";

export const ERROR_CODES = {
  "An account with the given email already exists.": {
    code: "EC409", // Email Conflict 409
    message: signUpDefaultMessage,
  },
  "Email Address Already Referred. Please use another or contact support@aptihealth.com": {
    code: "EC409", // Email Conflict 409
    message:
      "Error occurred while completing referral. Please contact support if the issue persists.",
  },
  SignUpDefault: {
    code: "EUNK", // Error Unknown
    message: signUpDefaultMessage,
  },
  WorkflowDefault: {
    code: "EUNK", // Error Unknown
    message: "Error updating workflow.",
  },
};

export const DENY_LIST_EXCEPTION_TYPE = "DenyListException";
